import { render } from "./SystemSettings.vue?vue&type=template&id=77cb69ea&ts=true"
import script from "./SystemSettings.vue?vue&type=script&lang=ts"
export * from "./SystemSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__